import { render, staticRenderFns } from "./Dialog_GetSemesterDetail.vue?vue&type=template&id=18d0a164&scoped=true&"
import script from "./Dialog_GetSemesterDetail.vue?vue&type=script&lang=js&"
export * from "./Dialog_GetSemesterDetail.vue?vue&type=script&lang=js&"
import style0 from "./Dialog_GetSemesterDetail.vue?vue&type=style&index=0&id=18d0a164&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d0a164",
  null
  
)

export default component.exports